document.addEventListener('DOMContentLoaded', function() {
  // General modal handling
  const modalTriggers = document.querySelectorAll('.request-privatbox');
  const modals = document.querySelectorAll('.general-privatbox-modal'); 
  const modalCloses = document.querySelectorAll('.modal-close');
  
  // Open modal when clicking trigger
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(event) {
      const modalId = this.dataset.modal;
      // Check if modalId contains 'privatbox-modal'
      if (modalId === 'privatbox-modal') {
        const modal = document.querySelector('.general-privatbox-modal');
        if (modal) {
          modal.classList.add('visible');
        }
      } else {
        // Fallback in case the data-modal value is the complete class name
        const modal = document.querySelector(`.${modalId}`);
        if (modal) {
          modal.classList.add('visible');
        }
      }
      
      // Prevent default behavior if it's a link
      if (this.tagName === 'A') {
        event.preventDefault();
      }
    });
  });
  
  // Close modal when clicking outside
  modals.forEach(modal => {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.classList.remove('visible');
      }
    });
  });
  
  // Close modal when clicking close button
  modalCloses.forEach(close => {
    close.addEventListener('click', function() {
      const modal = this.closest('.general-privatbox-modal');
      if (modal) {
        modal.classList.remove('visible');
      }
    });
  });
});